import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Field } from "@/components/articulo/Field";

export const NotaTab = ({ form, set, setForm, outletCategories }) => {
  const categoryOptions = [form.category, ...outletCategories]
    .filter((c, i, arr) => c && arr.indexOf(c) === i);
  const secondary = form.secondary_categories || [];

  return (
    <>
      <Field label="Titular">
        <Input value={form.title || ""} onChange={(e) => set("title", e.target.value)} className="mt-1.5" data-testid="title-input" />
      </Field>
      <Field label="Subtítulo" hint="Se envía al campo «Post Subtitle» de JNews.">
        <Input value={form.subtitle || ""} onChange={(e) => set("subtitle", e.target.value)} className="mt-1.5" data-testid="subtitle-input" />
      </Field>
      <Field label="Bajada / sumario">
        <Textarea rows={2} value={form.dek || ""} onChange={(e) => set("dek", e.target.value)} className="mt-1.5" data-testid="dek-input" />
      </Field>
      <Field label="Extracto" hint="Va al campo «Extracto» de WordPress: portadas, listados y compartidos.">
        <Textarea rows={2} value={form.excerpt || ""} onChange={(e) => set("excerpt", e.target.value)} className="mt-1.5" data-testid="excerpt-input" />
      </Field>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Categoría principal" hint="Va como categoría primaria de JNews.">
          <select
            value={form.category || ""}
            onChange={(e) => setForm((f) => ({
              ...f,
              category: e.target.value,
              secondary_categories: (f.secondary_categories || [])
                .filter((c) => c !== e.target.value),
            }))}
            className="w-full mt-1.5 h-10 border border-input bg-background px-3 text-sm rounded-md"
            data-testid="category-input"
          >
            {categoryOptions.map((c) => <option key={c} value={c}>{c}</option>)}
          </select>
        </Field>
        <Field label="Etiquetas (coma)">
          <Input
            value={(form.tags || []).join(", ")}
            onChange={(e) => set("tags", e.target.value.split(",").map((t) => t.trim()).filter(Boolean))}
            className="mt-1.5"
            data-testid="tags-input"
          />
        </Field>
      </div>
      <Field label="Categorías secundarias" hint="Hasta 4; se añaden a la entrada de WordPress.">
        <div className="flex flex-wrap gap-2 mt-1.5" data-testid="secondary-categories">
          {outletCategories.filter((c) => c !== form.category).map((c) => {
            const picked = secondary.includes(c);
            return (
              <button
                key={c}
                type="button"
                disabled={!picked && secondary.length >= 4}
                onClick={() => set("secondary_categories", picked
                  ? secondary.filter((x) => x !== c)
                  : [...secondary, c])}
                className={`text-xs px-3 py-1.5 border transition-colors ${
                  picked ? "border-primary bg-primary/10 text-foreground"
                         : "border-border text-muted-foreground hover:bg-muted/60 disabled:opacity-40"}`}
                data-testid={`secondary-cat-${c}`}
              >
                {c}
              </button>
            );
          })}
        </div>
        <p className="text-[11px] text-muted-foreground mt-2">
          {secondary.length} de 4 seleccionadas
        </p>
      </Field>
      <Field label="Cuerpo (HTML)">
        <Textarea rows={20} value={form.body_html || ""} onChange={(e) => set("body_html", e.target.value)} className="mt-1.5 mono text-xs" data-testid="body-input" />
      </Field>
    </>
  );
};

export const SeoTab = ({ form, setSeo, seoScore }) => (
  <>
    <div className="flex items-center gap-4 mb-6">
      <div className="text-5xl font-bold mono" data-testid="seo-score">{seoScore}</div>
      <div>
        <div className="kicker">Puntaje SEO</div>
        <div className="text-sm text-muted-foreground">
          {seoScore >= 80 ? "Excelente" : seoScore >= 60 ? "Aceptable, mejorable" : "Requiere trabajo"}
        </div>
      </div>
    </div>
    <Field label="Meta título" hint={`${(form.seo?.meta_titulo || "").length} / 65 caracteres`}>
      <Input value={form.seo?.meta_titulo || ""} onChange={(e) => setSeo("meta_titulo", e.target.value)} className="mt-1.5" data-testid="meta-title-input" />
    </Field>
    <Field label="Meta descripción" hint={`${(form.seo?.meta_descripcion || "").length} / 155 caracteres`}>
      <Textarea rows={3} value={form.seo?.meta_descripcion || ""} onChange={(e) => setSeo("meta_descripcion", e.target.value)} className="mt-1.5" data-testid="meta-desc-input" />
    </Field>
    <div className="grid sm:grid-cols-2 gap-4">
      <Field label="Slug">
        <Input value={form.seo?.slug || ""} onChange={(e) => setSeo("slug", e.target.value)} className="mt-1.5" data-testid="slug-input" />
      </Field>
      <Field label="Palabra clave">
        <Input value={form.seo?.palabra_clave || ""} onChange={(e) => setSeo("palabra_clave", e.target.value)} className="mt-1.5" data-testid="keyword-input" />
      </Field>
    </div>
    {(form.seo?.recomendaciones || form.seo_audit?.recomendaciones || []).length > 0 && (
      <div className="mt-4">
        <div className="kicker mb-2">Recomendaciones</div>
        <ul className="text-sm space-y-1.5 list-disc pl-5" data-testid="seo-recommendations">
          {(form.seo_audit?.recomendaciones || form.seo?.recomendaciones || []).map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>
      </div>
    )}
  </>
);
